import Box from '@mui/material/Box';
import { Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import React from 'react';
import PriceFilter from 'components/FilterFields/PriceFilter';
import AdvancedDateFilter from 'components/FilterFields/AdvancedDateFilter';
import ValuationConfidenceFilter from 'components/FilterFields/ValuationConfidenceFilter';

function PropertyValuesFilter(props) {
    return (
        <Box
            sx={{
                mb: 2,
                width: '100%',
            }}
        >
            <Typography sx={{ mb: 2.5, display: 'block' }} variant="text4" gutterBottom>Property Values</Typography>
            <Grid container spacing={3}>
                <Grid item size={6}>
                    <PriceFilter
                        label="Valuation Estimate Price"
                        subLabel="Select an option or manually enter a value"
                        attrName="latestConsumerSaleEstimate"
                        comparableType={props.comparableType}
                        isDropdown={false}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3} sx={{mt:3}}>
                <Grid item size={12}>
                    <ValuationConfidenceFilter
                        comparableType={props.comparableType}
                        columnSize={3}
                    />
                </Grid>
            </Grid>
            <Divider orientation="horizontal" sx={{mb:3, mt:3}}/>
            <Grid container spacing={3}>
                <Grid item size={6}>
                    <PriceFilter
                        label="Current Unimproved Land Value"
                        subLabel="Select an option or manually enter a value"
                        attrName="currentUnimprovedLandValue"
                        comparableType={props.comparableType}
                        isDropdown={false}
                    />
                </Grid>
                <Grid item size={6}>
                    <PriceFilter
                        label="Unimproved Capital Value"
                        subLabel="Select an option or manually enter a value"
                        attrName="unimprovedCapitalValue"
                        comparableType={props.comparableType}
                        isDropdown={false}
                    />
                </Grid>
                <Grid item size={5}>
                    <AdvancedDateFilter
                        header="Unimproved Capital Value Date"
                        comparableType={props.comparableType}
                        label="Select Range"
                        attr="unimprovedCapitalValueDate"
                        displayRight
                    />
                </Grid>
            </Grid>
            <Divider orientation="horizontal" sx={{mb:3, mt:3}}/>
        </Box>
    );
}

export default React.memo(PropertyValuesFilter);